import {
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
  Grid
} from '@mui/material'

interface PropertyDetails {
  streetNumber: string
  streetName: string
  unitNumber: string
  city: string
  state: string
  zipCode: string
  county: string
}

interface PropertyDetailsSectionProps {
  propertyDetails: PropertyDetails
  onChange: (field: keyof PropertyDetails, value: string) => void
  required?: boolean
}

export default function PropertyDetailsSection({
  propertyDetails,
  onChange,
  required = false
}: PropertyDetailsSectionProps) {
  return (
    <Card>
      <CardContent>
        <Stack spacing={1.5}>
          <Typography variant="subtitle1" fontWeight="bold">
            Property Information {!required && '(Optional)'}
          </Typography>

          <Grid container spacing={1.5}>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Street #"
                value={propertyDetails.streetNumber}
                onChange={(e) => onChange('streetNumber', e.target.value)}
                placeholder="123"
                required={required}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Street Name"
                value={propertyDetails.streetName}
                onChange={(e) => onChange('streetName', e.target.value)}
                placeholder="Main Street"
                required={required}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Unit #"
                value={propertyDetails.unitNumber}
                onChange={(e) => onChange('unitNumber', e.target.value)}
                placeholder="Apt 4B"
              />
            </Grid>
          </Grid>

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                value={propertyDetails.city}
                onChange={(e) => onChange('city', e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="State"
                value={propertyDetails.state}
                onChange={(e) => onChange('state', e.target.value.toUpperCase())}
                inputProps={{ maxLength: 2 }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="ZIP Code"
                value={propertyDetails.zipCode}
                onChange={(e) => onChange('zipCode', e.target.value)}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>
          </Grid>

          <TextField
            fullWidth
            label="County"
            value={propertyDetails.county}
            onChange={(e) => onChange('county', e.target.value)}
          />
        </Stack>
      </CardContent>
    </Card>
  )
}

